import React, { useEffect, useState, useCallback } from 'react'
import {
  Grid,
  Container,
  useMediaQuery
} from '@material-ui/core'
import {
  HeaderHLPure,
  ButtonHLPure,
  SimpleLoading,
  LabelModalPure,
  ButtonAddHLPure,
  SearchBarHLPure,
  DialogYesNoHLPure,
  DropDownBtnHLPure,
  DialogSystemGLPure,
  GridSelectionHLPure,
  PromotionalFooterPure,
} from '../../pures'
import AdministrationTypeDocumentForm from './administration-type-documents-form.view'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { filterBy } from '@progress/kendo-data-query'
import './administration-types-of-documents.css'
import { useTranslation } from 'react-i18next'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import AdministrationTypeDocumentDataProfile from './administration-type-documents-data-profile.view'
import AdministrationTypeDocumentsReassignModal from './administration-type-documents-reassign-modal.view'
import AdministrationTypeDocumentsDeleteWarningModal from './administration-type-documents-delete-warning-modal.view'

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t('configuration.AdministrationTypeDocuments.tableHeader.name')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
}

const CellColumnIcon = ({ dataItem }) => {
  const isDocumento = dataItem.infoType === 'Documento'
  const aggregateFieldsIcon = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Proceedings.svg'
  const filePdfIcon = 'https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/PDFIcon.svg'
  const iconSrc = isDocumento ? filePdfIcon : aggregateFieldsIcon

  return (
    <td>
      <div className='administration-types-of-documents-view__cell-content'>
        <img
          src={iconSrc}
          alt={isDocumento ? 'Documento' : 'Expediente'}
          className='administration-types-of-documents-view__icon'
        />
        <span><strong>{dataItem.document.name}</strong></span>
      </div>
    </td>
  )
}

const CellColumnText = ({ col, dataItem, t }) => {
  const ENV = process.env
  let content = ''
  if (col === 2) content = dataItem.name
  if (col === 3) {
    if (dataItem.dataProfile && dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_CONTRACT) content = t('configuration.AdministrationTypeDocuments.data.profile.contract')
    if (dataItem.dataProfile && dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_IDS) content = t('configuration.AdministrationTypeDocuments.data.profile.ids')
    if (dataItem.dataProfile && dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_PROOF_OF_ADDRESS) content = t('configuration.AdministrationTypeDocuments.data.profile.proofOfAddress')
  }

  return (
    <td>
      <div>
        <p className='grid-cell-subtitles'>{content}</p>
      </div>
    </td>
  )
}

const CellColumnStatusCell = ({ dataItem, t }) => {
  const isAssigned = dataItem.isInUse
  const label = isAssigned
    ? t('configuration.AdministrationTypeDocuments.status.assigned')
    : t('configuration.AdministrationTypeDocuments.status.unassigned')

  return (
    <td>
      <div>
        <span >{label}</span>
      </div>
    </td>
  )
}

const CellColumnBtns = (props) => {
  const { dataItem, t, onChangePage } = props
  const isInUse = dataItem.isInUse

  const assignedLabel = dataItem.infoType === 'Documento'
    ? t('configuration.AdministrationTypeDocuments.assignedDocuments')
    : t('configuration.AdministrationTypeDocuments.assignedFiles')

  return (
    <td>
      <div className='grid-btn-div'>
        <button className='grid-btn-action' onClick={() => onChangePage(t('configuration.AdministrationTypeDocuments.details'), dataItem)}>
          <p>{t('assembliesPrincipalView.grid.btns.detail')}</p>
        </button>
        <button className='grid-btn-action' onClick={() => onChangePage(t('assembliesPrincipalView.grid.btns.define.profile.data'), dataItem)}>
          <p>{t('assembliesPrincipalView.grid.btns.define.profile.data')}</p>
        </button>
        {isInUse && (
          <button className='grid-btn-action' onClick={() => onChangePage('assignedItems', dataItem)}>
            <p>{assignedLabel}</p>
          </button>
        )}
      </div>
      <div className='grid-btn-arrow' onClick={() => onChangePage(t('configuration.AdministrationTypeDocuments.details'), dataItem)}>
        <img alt='assemblies-arrow' src={ArrowBtnMobile} />
      </div >
    </td >
  )
}

const AdministrationTypesOfDocumentsView = (props) => {
  const {
    alerts,
    isLoading,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    toggleErrorRequestingFalse,
    messageError,
    selectedAlert,
    setViewDetails,
    setSelectedAlert,
    loadTypeDocuments,
    setNameComponentUser,
    dataProfileOptions,
    formatVariables,
    handleSumbitVariable,
    handleDeleteVariable,
    handleReassign,
    getAssignedItems,
    handleSaveTypeDocument,
    handleUpdateTypeDocument,
    deleteTypeDocument
  } = props

  const { t } = useTranslation()

  const [documentTypeFilter, setDocumentTypeFilter] = useState('0')
  const [selectPage, setSelectPage] = useState('Documento')
  const [viewMode, setViewMode] = useState('list')
  const [dataProfileSelected, setDataProfileSelected] = useState(null)

  const [textAreaValue, setTextAreaValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [analyzeAI, setAnalyzeAI] = useState(false)
  const [gridAction, setGridAction] = useState('')
  const [headerTitle, setHeaderTitle] = useState(t('configuration.AdministrationTypeDocuments.title2'))

  const [typeDocumentData, setTypeDocumentData] = useState([])

  const [viewDeleteDialog, setViewDeleteDialog] = useState(false)
  const [viewDeleteWarning, setViewDeleteWarning] = useState(false)
  const [viewReassignModal, setViewReassignModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)

  const is1600 = useMediaQuery('(max-width:1600px)')
  const is1200 = useMediaQuery('(max-width:1200px)')
  const is820 = useMediaQuery('(max-width:820px)')
  const is560 = useMediaQuery('(max-width:560px)')
  const hideActionsHeader = useMediaQuery('(max-width:912px)')

  let history = useHistory()

  let widthCellTwo = '100px'

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let CellColumnOne = (props) => <CellColumnIcon {...props} t={t} />
  let CellColumnTwo = (props) => <CellColumnText {...props} t={t} col={2} />
  let CellColumnThree = (props) => <CellColumnText {...props} t={t} col={3} />
  let CellColumnStatus = (props) => <CellColumnStatusCell {...props} t={t} />

  useEffect(() => {
    const filters = [
      {
        field: 'document.name',
        operator: 'contains',
        value: searchValue
      }
    ]

    if (documentTypeFilter === '1') {
      filters.push({ field: 'name', operator: 'eq', value: 'Documento' })
    } else if (documentTypeFilter === '2') {
      filters.push({ field: 'name', operator: 'eq', value: 'Expediente' })
    }

    const filter = {
      logic: 'and',
      filters
    }

    setTypeDocumentData(filterBy(alerts, filter))
  }, [alerts, searchValue, documentTypeFilter])

  const onSaveTypeDocument = async () => {
    if (!inputValue || !selectPage) {
      toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.incompleteFields'), 4000, false, '/')
      return
    }

    const success = await handleSaveTypeDocument({ name: inputValue, infoType: selectPage, description: textAreaValue, dataProfile: dataProfileSelected, analyzeAI })
    if (success) {
      setInputValue('')
      setSelectPage('')
      setTextAreaValue('')
      setViewMode('list')
      setHeaderTitle(t('configuration.AdministrationTypeDocuments.title2'))
      setDataProfileSelected(null)
      setNameComponentUser('Administración de tipos de documentos')
    }
  }

  const handleAddNewType = useCallback(() => {
    setInputValue('')
    setSelectPage('Documento')
    setTextAreaValue('')
    setAnalyzeAI(false)
    setViewMode('add')
    setNameComponentUser('Nuevo tipo de documento')
    setGridAction('add')
    setDataProfileSelected(null)
  }, [setViewMode, setNameComponentUser])

  const onUpdateTypeDocument = async () => {
    if (!inputValue || !selectPage || !selectedAlert) {
      toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.incompleteFields'), 4000, false, '/')
      return
    }

    const success = await handleUpdateTypeDocument({ id: selectedAlert.document.id, name: inputValue, infoType: selectPage, description: textAreaValue, dataProfile: dataProfileSelected, analyzeAI })
    if (success) {
      setHeaderTitle(t('configuration.AdministrationTypeDocuments.title2'))
      setViewMode('list')
      setNameComponentUser('Administración de tipos de documentos')
    }
  }

  useEffect(() => {
    if (viewMode === 'detail' && selectedAlert) {
      setInputValue(selectedAlert.document.name || '')
      setTextAreaValue(selectedAlert.document.description || '')
      setSelectPage(selectedAlert.infoType || 'Documento')
      setDataProfileSelected(selectedAlert.dataProfile || null)
      setAnalyzeAI(selectedAlert.analyzeAI || false)
    }

    if (viewMode === 'add') {
      const valueFilter = (documentTypeFilter === '2') ? 'Expediente' : 'Documento'
      setSelectPage(valueFilter)
    }
  }, [viewMode, selectedAlert])

  useEffect(() => {
    if (gridAction === '' || !selectedAlert || !selectedAlert.id) return
    switch (gridAction) {
      case 'add':
        setViewMode('add')
        setViewDetails(true)
        setHeaderTitle(t('configuration.AdministrationTypeDocuments.addHeader'))
        break
      case t('configuration.AdministrationTypeDocuments.details'):
        setViewMode('detail')
        setViewDetails(true)
        setHeaderTitle(t('configuration.AdministrationTypeDocuments.detailHeader', { typeDocumentName: (selectedAlert.document && selectedAlert.document.name) ? selectedAlert.document.name : '' }))
        break
      case t('assembliesPrincipalView.grid.btns.define.profile.data'):
        setViewMode('defineProfileData')
        setViewDetails(true)
        setHeaderTitle(t('configuration.AdministrationTypeDocuments.custom.data'))
        break
      case t('configuration.AdministrationTypeDocuments.assignedDocuments'):
        // setViewMode('assignedDocuments')
        setViewReassignModal(true)
        break
      case t('configuration.AdministrationTypeDocuments.delete'):
        // Conditional delete: if isInUse, show warning. If not, show confirm dialog.
        if (selectedAlert.isInUse) {
          setViewDeleteWarning(true)
        } else {
          setViewDeleteDialog(true)
        }
        break

      case 'assignedItems':
        setViewReassignModal(true)
        break
      default:
        break
    }

    setGridAction('')
  }, [selectedAlert, gridAction])

  const handleBackToList = useCallback(() => {
    setViewMode('list')
    setNameComponentUser('Administración de tipos de documentos')
    setHeaderTitle(t('configuration.AdministrationTypeDocuments.title2'))
    setSelectedAlert(null)
  }, [setViewMode, setNameComponentUser])

  const handleDeleteDocument = async () => {
    if (!selectedAlert) return
    const success = await deleteTypeDocument(selectedAlert.document.id)
    if (success) {
      setViewDeleteDialog(false)
      setSelectedAlert(null)
    }
  }

  useEffect(() => {
    if (confirmDelete) {
      handleDeleteDocument()
      setConfirmDelete(false)
    }
  }, [confirmDelete])

  const documentTypeOptions = [
    { id: '0', companyName: t('all') },
    { id: '1', companyName: t('configuration.AdministrationTypeDocuments.new.document') },
    { id: '2', companyName: t('configuration.AdministrationTypeDocuments.new.file') }
  ]

  const onChangePage = (page, varSelected) => {
    page = page || ''
    varSelected = varSelected || null
    setGridAction(page)
    setSelectedAlert(varSelected)
  }

  /**
   * @function handleTrashClick
   * @description Handles trash icon click from the grid. Shows warning if in use, confirm dialog if not.
   * @param {Object} dataItem
   * @returns {void}
   */
  const handleTrashClick = (dataItem) => {
    setSelectedAlert(dataItem)
    if (dataItem.isInUse) {
      setViewDeleteWarning(true)
    } else {
      setViewDeleteDialog(true)
    }
  }

  if (isLoading) return <div className='standard-wrapper'>
    <SimpleLoading />
  </div>

  return (
    <div className='standard-wrapper'>
      <div className='administrationTypesOfDocumentsView-header'>
        <HeaderHLPure title={headerTitle} />
      </div>
      <div className='administrationTypesOfDocumentsView-body'>
        {(viewMode === 'list') && (
          <div className='administrationTypesOfDocumentsView-wrapper'>
            <div className='administrationTypesOfDocumentsView-navbar'>
              <ButtonAddHLPure
                iconAdd
                onClickBtn={handleAddNewType}
                nameBtn={t('configuration.AdministrationTypeDocuments.addButton')}
              />
              <SearchBarHLPure
                searchValue={searchValue}
                onSearchChange={(e) => setSearchValue(e.target.value)}
                placeholder={t('configuration.AdministrationTypeDocuments.searchPlaceholder')}
              />
              <div className='administrationTypesOfDocumentsView-filter'>
                <DropDownBtnHLPure
                  iconFilter
                  valueItem='id'
                  nameOption='companyName'
                  optionsValue={documentTypeFilter}
                  optionsDropDown={documentTypeOptions}
                  onDropDownChange={(e) => setDocumentTypeFilter(e.target.value)}
                />
              </div>
            </div>
            <div className='administrationTypesOfDocumentsView-grid'>
              <GridSelectionHLPure
                skip={0}
                take={6}
                dataGrid={typeDocumentData}

                columnOne={true}
                titleRow1={t('configuration.AdministrationTypeDocuments.tableHeader.name')}
                cellColumnOne={CellColumnOne}
                headerColumnOne={AllHeadersColumns}

                columnTwo={true}
                titleRow2={t('configuration.AdministrationTypeDocuments.tableHeader.type')}
                cellColumnTwo={CellColumnTwo}
                headerColumnTwo={AllHeadersColumns}
                widthColumnTwo={'100px'}

                columnThree={(is820) ? false : true}
                titleRow3={t('configuration.AdministrationTypeDocuments.tableHeader.data.profile')}
                cellColumnThree={CellColumnThree}
                headerColumnThree={AllHeadersColumns}
                widthColumnThree={'130px'}

                columnFour={(is820) ? false : true}
                titleRow4={t('configuration.AdministrationTypeDocuments.tableHeader.status')}
                cellColumnFour={CellColumnStatus}
                headerColumnFour={AllHeadersColumns}
                widthColumnFour={'80px'}

                columnFive={true}
                titleRow5={'Acciones'}
                iconOneActive
                widthColumnFive={'600px'}
                labelOneActions={'Ver detalle'}
                iconTwoActive
                labelTwoActions={'Definir datos personalizados'}
                iconFifthActive
                labelFifthActions={'Documentos asignados'}
                activeDialogTrash
                btnOpenDialogTrash={handleTrashClick}
                labelTrashActions={t('configuration.AdministrationTypeDocuments.delete')}
                setNameComponentUser={(name) => setGridAction(name)}
                onSelectedItem={(item) => setSelectedAlert(item)}
                setShowDetails={() => { }}
              />
            </div>
            <div className='administrationTypesOfDocumentsView-btns'>
              <ButtonHLPure
                nameBtn={t('button.return')}
                onClickBtn={() => history.push('/configuration')}
              />
            </div>
          </div>
        )}
        {(viewMode === 'add' || viewMode === 'detail') && (
          <AdministrationTypeDocumentForm
            viewMode={viewMode}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
            inputValue={inputValue}
            setInputValue={setInputValue}
            selectPage={selectPage}
            setSelectPage={setSelectPage}
            textAreaValue={textAreaValue}
            setTextAreaValue={setTextAreaValue}
            analyzeAI={analyzeAI}
            setAnalyzeAI={setAnalyzeAI}
            handleCancel={handleBackToList}
            handleSubmit={viewMode === 'add' ? onSaveTypeDocument : onUpdateTypeDocument}
            dataProfileOptions={dataProfileOptions}
            setDataProfileSelected={setDataProfileSelected}
            dataProfileSelected={dataProfileSelected}
          />
        )}
        {(viewMode === 'defineProfileData') && (
          <AdministrationTypeDocumentDataProfile
            t={t}
            handleCancel={handleBackToList}
            typeDocumentSelected={selectedAlert}
            formatVariables={formatVariables}
            handleSumbitVariable={handleSumbitVariable}
            handleDeleteVariable={handleDeleteVariable}
          />
        )}
        {viewDeleteDialog && selectedAlert && !selectedAlert.isInUse && (
          <DialogYesNoHLPure
            cancel={() => {
              setViewDeleteDialog(false)
              setGridAction('')
            }} textBtnCancel={t('button.cancel')}
            saveBtn={t('button.delete')}
            titleDialog={`${t('configuration.AdministrationTypeDocuments.delete.confirm.title')}`}
            handleSubmit={() => {
              setConfirmDelete(true)
            }}
          >
            <div className='digitalVaultBinView-modal-delete'>
              <LabelModalPure
                label={
                  selectedAlert?.document?.name && selectedAlert?.infoType
                    ? t('configuration.AdministrationTypeDocuments.delete.confirm.body')
                    : ''
                }
              />
            </div>
          </DialogYesNoHLPure>
        )}
        {viewDeleteWarning && selectedAlert && selectedAlert.isInUse && (
          <AdministrationTypeDocumentsDeleteWarningModal
            onClose={() => {
              setViewDeleteWarning(false)
              setGridAction('')
            }}
            t={t}
          />
        )}
        {viewReassignModal && selectedAlert && (
          <AdministrationTypeDocumentsReassignModal
            typeDocumentSelected={selectedAlert}
            allTypeDocuments={alerts}
            onClose={() => {
              setViewReassignModal(false)
              setGridAction('')
            }}
            onReassign={handleReassign}
            getAssignedItems={getAssignedItems}
            t={t}
          />
        )}
      </div>
      <div className='administrationTypesOfDocumentsView-footer'>
        <PromotionalFooterPure />
      </div>
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}

        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}

        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleErrorRequestingFalse}
        messageError={messageError}
      />
    </div>
  )
}

export default AdministrationTypesOfDocumentsView